import React from 'react'
import { InfoHeader } from '@mobi/component-library/Typography/InfoHeader'
import { spacing } from '@mobi/component-library/Theme/Common'
import { queryClient } from '@core/Data/ReactQuery'
import { MainContainer } from '@core/Components/Containers'
import { trackBetLoopRestrictedAccess } from '@core/Areas/BetLoop/helpers/analytics'
import { betLoopPrincipleProfileQuery } from '@core/Areas/BetLoop/helpers/queries'

const enum LocalConstants {
  BannedTitle = `You don’t currently have\n access to Bet Loop`,
  UnavailableTitle = 'Bet Loop is currently unavailable',
  UnavailableSubtitle = 'We’re experiencing a temporary outage and are working to restore service as quickly as possible.',
}

export const RestrictedAccess: React.FC<{ status: 'banned' | 'unavailable' }> = ({ status }) => {
  React.useEffect(() => {
    if (status === 'banned') trackBetLoopRestrictedAccess()
    if (status === 'unavailable') queryClient.refetchQueries(betLoopPrincipleProfileQuery)
  }, [status])

  let title = LocalConstants.BannedTitle
  let subtitle: string | undefined = undefined

  if (status === 'unavailable') {
    title = LocalConstants.UnavailableTitle
    subtitle = LocalConstants.UnavailableSubtitle
  }

  return (
    <MainContainer
      testId='BetLoop.BlockedAccess'
      style={{ justifyContent: 'center', padding: spacing.md }}
      background='white'
    >
      <InfoHeader size='large' icon='warning' headerText={title} subHeaderText={subtitle} />
    </MainContainer>
  )
}
